import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { _HttpServices } from "../../_services/_HttpServices";
import ReactTable from "../../components/FilterTable";
import { Button } from "react-bootstrap";
import { IoMdCreate, IoIosAdd, IoMdDownload } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Toast } from "react-bootstrap";
// Local imports
import Loader from "../../components/Loader";
import getExcel from "../../_services/ExcelUtility";
import moment from 'moment'
import { Footer } from "../../components/Footer";
// const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
const UsersPage = ({ dispatch, login }) => {
  const fileName = 'Users';
  const history = useHistory();
  const [users, setUsersData] = useState([]);
  const [showToaster, setShowToaster] = useState(false);
  const [userUpdated, setUserUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [usersError, setUsersError] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState({});

  useEffect(() => {
    getUserData();
    if (localStorage.getItem("added")) {
      setShowToaster(true);
      setTimeout(() => {
        localStorage.removeItem("added");
      }, 3000);
    }
    if (localStorage.getItem("updated")) {
      setUserUpdated(true);
      setShowToaster(true);
      setTimeout(() => {
        localStorage.removeItem("updated");
        setUserUpdated(false);
      }, 3000);
    }
    if (localStorage.getItem("userData")) {
      setLoggedInUserData(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);
  const getUserData = () => {
    
    if(!localStorage.getItem("allUsers")){
      setLoading(true);
    _HttpServices
      .getData("api/user/allusers")
      .then((data) => {
        const changeUserList = data.data.map((item, index) => {
          if (item.RoleID === 1) {
            item.RoleID = "Admin";
          }
          if (item.RoleID === 2) {
            item.RoleID = "User";
          }
          if (item.Status === false) {
            item.Status = "Inactive";
          }
          if (item.Status === true) {
            item.Status = "Active";
          }
          item.Createddate = moment(item.Createddate).format('MM/DD/YYYY');
          item.Modifieddate = moment(item.Modifieddate).format('MM/DD/YYYY');
          return item;
        });
        let filteredUsers;
        if (JSON.parse(localStorage.getItem("userData")).Id) {
          filteredUsers = changeUserList.filter((item) => { return item.Id !== JSON.parse(localStorage.getItem("userData")).Id })
          setUsersData(filteredUsers);
          localStorage.setItem("allUsers",JSON.stringify(filteredUsers));
        } else {
          filteredUsers = changeUserList;
          localStorage.setItem("allUsers",JSON.stringify(filteredUsers));
          setUsersData(filteredUsers);
        }
        setLoading(false);
      })

    
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setUsersError(true)
      });
    }else{
      let data = JSON.parse(localStorage.getItem("allUsers"))
                if(data === null){
                    data =[];
                }
      setUsersData(data);
    }
  };
  let columns = []
  if (loggedInUserData.RoleID === 1) {
    columns = [
      {
        Header: "Actions",
        accessor: "accessor",
        disableFilters: true,
        disableSortBy: true,
        width: 80,
        Cell: ({ row: { original } }) => (
          <Fragment>
            {loggedInUserData.RoleID !== 2 && original.UserName !== 'Admin' && (
              <Button
                variant="link"
                title="Edit User"
                onClick={() =>
                  localStorage.setItem(
                    "editUserData",
                    JSON.stringify(original),
                    history.push("/adduser")
                  )
                }
                className="grid-action-btn"
              >
                <IoMdCreate className="icon" />
              </Button>
            )}
          </Fragment>
        ),
      },
      {
        Header: "First Name",
        accessor: "FirstName",
        filter: "FirstName",
        sortType: "basic",
      },
      {
        Header: "Last Name",
        accessor: "LastName",
        filter: "LastName",
        sortType: "basic",
      },
      {
        Header: "User Name",
        accessor: "UserName",
        filter: "UserName",
        sortType: "basic",
      },
      {
        Header: "Contact Number",
        accessor: "ContactNumber",
        filter: "ContactNumber",
        sortType: "basic",
      },
      {
        Header: "Email Id",
        accessor: "EmailID",
        filter: "EmailID",
        sortType: "basic",
        width: 200,
        Cell: ({ row: { original } }) => (
          <Fragment>
            <span className="word-wrap">{original.EmailID}</span>
          </Fragment>
        )
      },
      {
        Header: "Role",
        accessor: "RoleID",
        filter: "RoleID",
        sortType: "basic",
        width: 80
      },
      {
        Header: "Status",
        accessor: "Status",
        filter: "Status",
        sortType: "basic",
      },
      {
        Header: "Created Date",
        accessor: "Createddate",
        filter: "Createddate",
        sortType: "basic",
      },
      {
        Header: "Modified Date",
        accessor: "Modifieddate",
        filter: "Modifieddate",
        sortType: "basic",
      },
      {
        Header: "Modified By",
        accessor: "ModifiedBy",
        filter: "ModifiedBy",
        sortType: "basic",
      }
    ];
  }
  if (loggedInUserData.RoleID === 2) {
    columns = [
      {
        Header: "First Name",
        accessor: "FirstName",
        filter: "FirstName",
        sortType: "basic",
      },
      {
        Header: "Last Name",
        accessor: "LastName",
        filter: "LastName",
        sortType: "basic",
      },
      {
        Header: "User Name",
        accessor: "UserName",
        filter: "UserName",
        sortType: "basic",
      },
      {
        Header: "Contact Number",
        accessor: "ContactNumber",
        filter: "ContactNumber",
        sortType: "basic",
      },
      {
        Header: "Email Id",
        accessor: "EmailID",
        filter: "EmailID",
        sortType: "basic",
      },
      {
        Header: "Role",
        accessor: "RoleID",
        filter: "RoleID",
        sortType: "basic",
      },
      {
        Header: "Status",
        accessor: "Status",
        filter: "Status",
        sortType: "basic",
      },{
        Header: "Created Date",
        accessor: "Createddate",
        filter: "Createddate",
        sortType: "basic",
      },
      {
        Header: "Modified Date",
        accessor: "Modifieddate",
        filter: "Modifieddate",
        sortType: "basic",
      },
      {
        Header: "Modified By",
        accessor: "ModifiedBy",
        filter: "ModifiedBy",
        sortType: "basic",
      }
    ];
  }

  const addUserHandler = () => {
    localStorage.removeItem("editUserData");
    history.push("/adduser");
  };

  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Users</h2>
        <div>
          {loggedInUserData.RoleID !== 2 && (
            <Button onClick={() => addUserHandler()}>
              <IoIosAdd className="icon btn-icon" />
            Add User
            </Button>
          )}
          <Button className="ml-2" onClick={() => getExcel(columns, users, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button>
        </div>
        {/* <Button disabled={loggedInUserData.RoleID === 2 ? true : false} onClick={() => addUserHandler()}><IoIosAdd className="icon btn-icon" />Add User</Button> */}
      </div>
      {/* Toaster */}
      <Toast
        onClose={() => setShowToaster(false)}
        show={showToaster}
        delay={1500}
        autohide
        className="custom-toaster"
      >
        {/* <Toast.Header>
          <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
          <strong className="mr-auto">Woohoo!!</strong>
        </Toast.Header> */}
        {!userUpdated && <Toast.Body>User Added Successfully</Toast.Body>}
        {userUpdated && <Toast.Body>User Updated Successfully</Toast.Body>}
      </Toast>
      {/* <h1>Users</h1>
            <NavLink to="/adduser">Add User</NavLink> */}
      <div className="users-grid-wrap">
        <div className="card pt-3">
          <div className="card-body">
            {
              users.length > 0 ? <ReactTable columns={columns} data={users} defaultPageSize={10} /> : 
              usersError ? <p>Error occurred. Unable to load queue files.</p> :
              <div className="no-data">No data found.</div>
            }
          </div>
        </div>
      </div>
      {loading ? <Loader /> : null}

      <Footer />
    </section>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(UsersPage);
